import styles from "./MapsDropdown.module.scss";

export const Dropdown = (props: {
  handleSelect: ({
    description,
    place_id,
  }: {
    description: any;
    place_id: string;
  }) => void;
  data: any;
}) => {
  return (
    <ul
      className={`${styles.dropdown} ${styles.active_dropdown}`}
      data-testid="maps-dropdown"
    >
      {props.data.map((suggestion: any, index: number) => {
        const isPeliasData = suggestion.display_name !== undefined;

        let mainText, secondaryText, placeId;

        if (isPeliasData) {
          const displayName = suggestion.display_name;
          const parts = displayName.split(", ");
          mainText = parts[0] || displayName;
          secondaryText = parts.slice(1).join(", ") || "";
          placeId = suggestion.place_id.toString();
        } else {
          const {
            place_id,
            structured_formatting: { main_text, secondary_text },
          } = suggestion;

          mainText = main_text;
          secondaryText = secondary_text;
          placeId = place_id;
        }

        return (
          <li
            key={placeId}
            data-testid={`maps-dropdown-item-${index}`}
            className={`${styles.active_link}`}
            onClick={() => {
              props.handleSelect({
                description: isPeliasData
                  ? suggestion.display_name
                  : suggestion.description,
                place_id: placeId,
              });
            }}
          >
            <strong>{mainText}</strong> <small>{secondaryText}</small>
          </li>
        );
      })}
    </ul>
  );
};
